module.exports = __webpack_public_path__ + "../resources/img/ic_arrow_left.993dc234.svg";